import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmailIcon from '../../../../../assets/icons/email.svg';
import PhoneIcon from '../../../../../assets/icons/phone-icon.svg';
import { LANG_TEXT } from '../../../../../constants/language';
import { IGiftInfo } from '../../../order.types';

const SeatInfor: React.FC<{ email?: string; phone?: string; giftInfo?: IGiftInfo; sendMail: () => Promise<void> }> = ({ email, phone, giftInfo, sendMail }) => {
  const { t } = useTranslation();

  function detectEmailOrPhone(value: string | null) {
    if (!value) return null;
    const input = value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?\d{8,15}$/;
    if (emailRegex.test(input)) {
      return 'email';
    }

    if (phoneRegex.test(input)) {
      return 'phone';
    }

    return 'invalid';
  }

  const maskEmail = (email: string): string => {
    const atIdx = email.indexOf('@');
    if (atIdx < 0) return email;
    const local = email.slice(0, atIdx);
    const rest = email.slice(atIdx + 1);
    const dotIdx = rest.lastIndexOf('.');
    const domainName = dotIdx > 0 ? rest.slice(0, dotIdx) : rest;
    const tld = dotIdx > 0 ? rest.slice(dotIdx) : '';
    const maskedLocal = local.slice(0, 2) + '*'.repeat(Math.max(local.length - 2, 3));
    const maskedDomain = domainName.slice(0, 1) + '*'.repeat(Math.max(domainName.length - 1, 5));
    return `${maskedLocal}@${maskedDomain}${tld}`;
  };

  const maskPhone = (phone: string): string => {
    const digits = phone.replace(/\D/g, '');
    if (digits.length < 7) return phone;
    return `${digits.slice(0, 3)}-****-${digits.slice(-4)}`;
  };

  const maskValue = (value: string): string => {
    const type = detectEmailOrPhone(value);
    if (type === 'email') return maskEmail(value);
    if (type === 'phone') return maskPhone(value);
    return value;
  };

  const handlePhoneClick = (phone: string) => {
    window.location.href = `tel:${phone}`;
  };

  const renderContactRow = (value: string, icon: string, onClick: () => void) => (
    <Box
      display="flex" alignItems="center" gap="16px"
      bgcolor="white" padding="16px" borderRadius="12px"
      border="1px solid #EAECF0"
    >
      <Box display="flex" flexDirection="column" gap="4px" flex={1}>
        <Typography fontSize="14px" color="#667085" fontWeight="500">
          {t(LANG_TEXT.REPORT_TEXT)}
        </Typography>
        <Typography fontSize="16px" color="#1D2939" fontWeight="600">
          {maskValue(value)}
        </Typography>
      </Box>
      <Box
        width={40} height={40} borderRadius="50%" bgcolor="#E2F6E4"
        display="flex" alignItems="center" justifyContent="center"
        sx={{ cursor: 'pointer' }}
        onClick={onClick}
      >
        <img width={20} height={20} src={icon} alt="" />
      </Box>
    </Box>
  );

  return (
    <Box bgcolor="#F9FAFB" display="flex" flexDirection="column" gap="8px" borderBottom="1px solid #EAECF0">
      {giftInfo ? (
        <>
          {giftInfo.receiver_phone && (
            <Box
              display="flex" alignItems="center" gap="16px"
              bgcolor="white" padding="16px" borderRadius="12px"
              border="1px solid #EAECF0"
            >
              <Box display="flex" flexDirection="column" gap="4px" flex={1}>
                <Typography fontSize="14px" color="#667085" fontWeight="500">
                  {t(LANG_TEXT.REPORT_TEXT)}
                </Typography>
                <Typography fontSize="16px" color="#1D2939" fontWeight="600">
                  {maskPhone(giftInfo.receiver_phone)}
                </Typography>
              </Box>
              <Box
                width={40} height={40} borderRadius="50%" bgcolor="#E2F6E4"
                display="flex" alignItems="center" justifyContent="center"
                sx={{ cursor: 'pointer' }}
                onClick={() => handlePhoneClick(giftInfo.receiver_phone!)}
              >
                <img width={20} height={20} src={PhoneIcon} alt="phone" />
              </Box>
            </Box>
          )}
          {giftInfo.receiver_email && (
            <Box
              display="flex" alignItems="center" gap="16px"
              bgcolor="white" padding="16px" borderRadius="12px"
              border="1px solid #EAECF0"
            >
              <Box display="flex" flexDirection="column" gap="4px" flex={1}>
                <Typography fontSize="14px" color="#667085" fontWeight="500">
                  {t(LANG_TEXT.REPORT_TEXT)}
                </Typography>
                <Typography fontSize="16px" color="#1D2939" fontWeight="600">
                  {maskEmail(giftInfo.receiver_email)}
                </Typography>
              </Box>
              <Box
                width={40} height={40} borderRadius="50%" bgcolor="#E2F6E4"
                display="flex" alignItems="center" justifyContent="center"
                sx={{ cursor: 'pointer' }}
                onClick={() => sendMail()}
              >
                <img width={20} height={20} src={EmailIcon} alt="email" />
              </Box>
            </Box>
          )}
        </>
      ) : (
        <>
          {phone && renderContactRow(phone, PhoneIcon, () => handlePhoneClick(phone))}
          {email && renderContactRow(email, EmailIcon, sendMail)}
          {!email && !phone && null}
        </>
      )}
    </Box>
  );
};

export default SeatInfor;
